/**
 * « Comment réussir ce type de question ? » (D-107): a link from the exam player and the correction
 * to the method lesson of the section and of the task (TCF) or of the question type (IELTS).
 * Nothing is shown while there is no method lesson for it.
 */

import { useAcademyCourseMethodLinkRetrieve } from "@agencyos/api-client";
import { methodQuery } from "@agencyos/core";
import { Lightbulb } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


export function MethodLink({ exam, skill, task, type, newTab = false, compact = false }: { exam: string; skill: string; task?: number | string | null; type?: string | null; newTab?: boolean; compact?: boolean }) {
  const { t } = useTranslation();
  const query = useAcademyCourseMethodLinkRetrieve(methodQuery(exam, skill, { task, type }), { query: { retry: false, staleTime: 600_000, enabled: Boolean(skill) } });
  const lesson = query.data?.status === 200 ? query.data.data.lesson : null;
  if (!lesson) return null;
  return (
    <Link
      className={`ac-method-link${compact ? " ac-method-link--icon" : ""}`}
      title={compact ? t("academyCourse.method.how") : undefined}
      to={`/academy/course/lesson/${lesson}`}
      {...(newTab ? { target: "_blank", rel: "noopener" } : {})}
    >
      <Lightbulb aria-hidden size={15} />
      <span className={compact ? "visually-hidden" : undefined}>{t("academyCourse.method.how")}</span>
    </Link>
  );
}
